import { useDispatch } from "react-redux";

import { useQuery } from "@tanstack/react-query";

import { apiThatThrows } from "containers/Request";
import { unique } from "utils/array";

export const useAppsByIds = (appIds: string[], enabled: boolean) => {
  const dispatch = useDispatch();

  const ids = unique(appIds).filter(Boolean).sort();

  return useQuery({
    queryKey: ["appsByIds", ids.join(";")],
    queryFn: async () => {
      if (ids.length === 0) {
        return { results: [] };
      }
      return dispatch(
        apiThatThrows.searchApplicationsPaginated.action({
          queryParams: { id: ids, limit: ids.length || 1, page: 1 },
        })
      );
    },
    enabled,
  });
};
